import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../style.scss';
import { BasePreview } from './BasePreview';
import { getSingleAssetId, getSingleAsset, getSingleAssetError } from '../selectors';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as fullscreenPreviewActions from '../actions';

export const SinglePreview: React.FC<{ back: string }> = ({ back }) => {
  const dispatch = useDispatch();
  const paramsAssetId = Number(useParams<{ assetID: string }>().assetID);
  const assetId = useSelector(getSingleAssetId);
  const asset = useSelector(getSingleAsset);
  const error = useSelector(getSingleAssetError);

  useEffect(() => {
    if (assetId !== paramsAssetId) {
      dispatch(fullscreenPreviewActions.assetIdChanged({ id: paramsAssetId }));
    }
  }, [assetId, paramsAssetId, dispatch]);

  return (
    <BasePreview back={back} asset={asset?.id === paramsAssetId ? asset : null} error={error} />
  );
};
